export default {
  siteName: 'RPM Consulting, Inc.',
  siteUrl: 'https://rpmconsultinginc.com',
  contacts: {
    email: 'notifications@rpmconsultinginc.com',
    phoneNo: '406-259-4878',
    address: '2110 Overland Ave, Ste 105, Billings, MT 59102',
  },
  nav: {
    indexSlug: 'index',
    indexTitle: 'Home',
    contactsSlug: 'contact',
  },
};



// WEBPACK FOOTER //
// ./src/config.js